import React, { useContext } from 'react';
import { FiInfo } from 'react-icons/fi';
import { LoginContext } from '../../Contexts/LoginContext';

const PayoutFeeNote = ({ variant = 'default' }) => {
  const { payoutFeeApplies } = useContext(LoginContext);

  if (!payoutFeeApplies) return null;

  const message = variant === 'withdrawal'
    ? 'A payment gateway payout fee applies to this withdrawal and will be deducted from the amount you receive.'
    : 'A payment gateway payout fee also applies when you withdraw your earnings.';

  return (
    <p className="payoutFeeSellerNote">
      <FiInfo className="payoutFeeSellerNoteIcon" /> {message}
    </p>
  );
};

export default PayoutFeeNote;
